import React from 'react';
import { STATUS_LABELS, STATUS_STYLES } from './api';

// same pill style as the customer contracts list (ring-inset)
const StatusBadge: React.FC<{ status: string }> = ({ status }) => (
  <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset ${STATUS_STYLES[status] || STATUS_STYLES.expired}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export default StatusBadge;
